module.exports = __webpack_public_path__ + "img/06.098d4652.png";